module.exports = __webpack_public_path__ + "img/blank.59de2200.png";